<template>
  <div class="retest-submit-form">
    <el-form 
      ref="retestForm" 
      :model="form" 
      :rules="rules" 
      label-width="120px"
      class="retest-form">
      
      <!-- 订单基本信息 -->
      <el-card class="form-card">
        <div slot="header">
          <span>订单基本信息</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="项目名称" prop="projectName">
              <el-input v-model="form.projectName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订单编号" prop="orderNo">
              <el-input v-model="form.orderNo" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="商家名称" prop="merchantName">
              <el-input v-model="form.merchantName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户名称" prop="customerName">
              <el-input v-model="form.customerName" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="仪器信息" prop="deviceInfo">
              <el-input v-model="form.deviceInfo" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="仪器型号" prop="deviceModel">
              <el-input v-model="form.deviceModel" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <!-- 测试要求和结果信息 -->
      <el-card class="form-card">
        <div slot="header">
          <span>测试信息</span>
        </div>
        
        <!-- 测试要求附件 -->
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="测试要求附件">
              <div v-if="form.requirementFiles && form.requirementFiles.length > 0" class="file-list-container">
                <el-table
                  :data="form.requirementFiles"
                  style="width: 100%"
                  border>
                  <el-table-column
                    prop="name"
                    label="文件名"
                    min-width="300">
                  </el-table-column>
                  <el-table-column
                    prop="size"
                    label="大小"
                    width="150">
                    <template slot-scope="scope">
                      {{ formatFileSize(scope.row.size) }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    width="150"
                    align="center">
                    <template slot-scope="scope">
                      <el-button 
                        type="text" 
                        size="small" 
                        @click="handlePreview(scope.row)">预览</el-button>
                      <el-button 
                        type="text" 
                        size="small" 
                        @click="handleDownload(scope.row)" 
                        style="margin-left: 10px;">下载</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div v-else class="no-file">
                <el-empty description="暂无测试要求附件"></el-empty>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        
        <!-- 测试结果附件 -->
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="测试结果附件">
              <div v-if="form.resultFiles && form.resultFiles.length > 0" class="file-list-container">
                <el-table
                  :data="form.resultFiles"
                  style="width: 100%"
                  border>
                  <el-table-column
                    prop="name"
                    label="文件名"
                    min-width="300">
                  </el-table-column>
                  <el-table-column
                    prop="size"
                    label="大小"
                    width="150">
                    <template slot-scope="scope">
                      {{ formatFileSize(scope.row.size) }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    width="150"
                    align="center">
                    <template slot-scope="scope">
                      <el-button 
                        type="text" 
                        size="small" 
                        @click="handlePreview(scope.row)">预览</el-button>
                      <el-button 
                        type="text" 
                        size="small" 
                        @click="handleDownload(scope.row)" 
                        style="margin-left: 10px;">下载</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div v-else class="no-file">
                <el-empty description="暂无测试结果附件" :image-size="60"></el-empty>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        
        <!-- 测试说明 -->
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="测试结果说明">
              <el-input v-model="form.testDescription" type="textarea" :rows="3" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <!-- 申请复测信息 -->
      <el-card class="form-card">
        <div slot="header">
          <span>申请复测信息</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="复测原因" prop="retestReason">
              <el-input 
                type="textarea" 
                v-model="form.retestReason"
                :rows="4"
                placeholder="请详细描述申请复测的原因">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="复测附件" prop="fileList">
              <el-upload
                class="upload-demo"
                action="#"
                :http-request="handleFileUpload"
                :file-list="[]"
                :on-remove="handleRemove"
                :before-upload="beforeUpload"
                drag
                multiple
                :limit="5"
                :show-file-list="false">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">
                  上传复测申请相关文件，支持PDF、Word、Excel、图片或压缩包(ZIP/RAR/7Z)等格式
                </div>
              </el-upload>
              
              <!-- 已上传文件列表 -->
              <div v-if="form.fileList && form.fileList.length > 0" class="uploaded-files">
                <h3 class="file-list-title">已上传文件</h3>
                <el-table
                  :data="form.fileList"
                  style="width: 100%; margin-top: 15px;"
                  border>
                  <el-table-column
                    prop="name"
                    label="文件名"
                    min-width="300">
                  </el-table-column>
                  <el-table-column
                    prop="size"
                    label="大小"
                    width="150">
                    <template slot-scope="scope">
                      {{ formatFileSize(scope.row.size) }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    width="180"
                    align="center">
                    <template slot-scope="scope">
                      <el-button 
                        type="text" 
                        size="small" 
                        @click="handlePreview(scope.row)">预览</el-button>
                      <el-button 
                        type="text" 
                        size="small" 
                        @click="handleDownload(scope.row)" 
                        style="margin-left: 10px;">下载</el-button>
                      <el-button 
                        type="text" 
                        size="small"
                        style="color: #F56C6C; margin-left: 10px;"
                        @click="handleRemoveUploaded(scope.$index)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <!-- 操作按钮 -->
      <div class="form-actions">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">提交复测申请</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import adminApi from '@/api/adminApi'

export default {
  name: 'RetestSubmitForm',
  props: {
    orderId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      form: {
        orderNo: '',
        createTime: '',
        deviceType: '',
        deviceCount: '',
        retestReason: '',
        fileList: [],
        projectName: '',
        merchantName: '',
        customerName: '',
        deviceInfo: '',
        sampleCount: '',
        requirementFiles: [],
        resultFiles: [],
        testDescription: '',
        deviceModel: ''
      },
      rules: {
        retestReason: [
          { required: true, message: '请输入复测原因', trigger: 'blur' }
        ],
        fileList: [
          { required: false, message: '请上传复测相关文件', trigger: 'change' }
        ]
      },
      uploadingFiles: 0
    }
  },
  created() {
    if (this.orderId) {
      this.getOrderDetail()
    } else {
      console.error('缺少订单ID')
      this.$message.error('缺少订单ID，无法获取订单详情')
    }
  },
  methods: {
    async getOrderDetail() {
      try {
        const res = await adminApi.getOrderById(this.orderId)
        console.log('获取到的订单详情:', res)
        if (res) {
          const orderData = res
          
          // 处理测试要求附件
          const requirementFiles = Array.isArray(orderData.orderFile) 
            ? orderData.orderFile.map(file => ({
                name: file.fileName || '未命名文件',
                size: file.fileSize || 0,
                url: file.fileUrl || file.url || '',
                fileId: file.fileId || file.id
              })) 
            : [];
          
          // 处理测试结果附件
          const resultFiles = Array.isArray(orderData.orderResultFile) 
            ? orderData.orderResultFile.map(file => ({
                name: file.fileName || '未命名文件',
                size: file.fileSize || 0,
                url: file.fileUrl || file.url || '',
                fileId: file.fileId || file.id
              })) 
            : [];
          
          this.form = {
            ...this.form,
            orderNo: orderData.orderSn || '',
            createTime: orderData.createTime || '',
            deviceType: orderData.deviceType || '',
            deviceCount: orderData.testCount || '',
            projectName: orderData.projectName || '',
            merchantName: orderData.merchantName || '',
            customerName: orderData.customerName || '',
            deviceInfo: orderData.deviceName || '',
            sampleCount: orderData.testCount || '',
            requirementFiles: requirementFiles,
            resultFiles: resultFiles,
            testDescription: orderData.testResultRemark || '',
            deviceModel: orderData.deviceModel || ''
          }
        } else {
          this.$message.error('获取订单详情失败')
        }
      } catch (error) {
        console.error('获取订单详情失败:', error)
        this.$message.error('获取订单详情失败: ' + (error.message || '未知错误'))
      }
    },
    handleCancel() {
      this.$router.back()
    },
    handleSubmit() {
      this.$refs.retestForm.validate(async valid => {
        if (valid) {
          if (this.uploadingFiles > 0) {
            this.$message.warning(`还有 ${this.uploadingFiles} 个文件正在上传，请等待上传完成后再提交`)
            return
          }

          try {
            const params = {
              id: this.orderId,
              orderSn: this.form.orderNo,
              orderStatus: 'RETESTING',
              disputeRemark: this.form.retestReason,
              disputeType: 1,
              orderDisputeFile: this.form.fileList.map(file => ({
                fileId: file.fileId,
                fileName: file.name,
                filePath: file.path,
                fileUrl: file.url,
                fileSize: file.size
              }))
            }
            
            const res = await adminApi.submitDispute(params)
            if (res) {
              this.$message.success('复测申请提交成功')
              
              // 根据用户角色决定跳转路径
              const userRole = localStorage.getItem('userRole')
              if (userRole === 'merchant') {
                // 商家端跳转到商家的订单页面
                this.$router.push('/merchant/orders/dispute')
              } else {
                // 管理员端跳转到管理员的订单页面
                this.$router.push('/admin/orders/dispute')
              }
            } else {
              this.$message.error('复测申请提交失败')
            }
          } catch (error) {
            console.error('提交复测申请失败:', error)
            this.$message.error('提交复测申请失败: ' + (error.message || '未知错误'))
          }
        }
      })
    },
    formatFileSize(size) {
      if (!size) return '0 B'
      const units = ['B', 'KB', 'MB', 'GB']
      let index = 0
      while (size >= 1024 && index < units.length - 1) {
        size /= 1024
        index++
      }
      return size.toFixed(2) + ' ' + units[index]
    },
    handlePreview(file) {
      // 调用统一的预览方法
      adminApi.previewFile(file, this.$message)
        .catch(error => {
          console.error('文件预览失败:', error);
        });
    },
    handleDownload(file) {
      // 调用统一的下载方法
      adminApi.downloadFileUnified(file, this.$message)
        .catch(error => {
          console.error('文件下载失败:', error);
        });
    },
    async handleFileUpload(options) {
      const { file } = options
      this.uploadingFiles++
      
      try {
        const res = await adminApi.uploadFile(file, '', (percent) => {
          console.log(`上传进度: ${parseInt(percent)}%`)
        })
        
        if (res) {
          const fileData = res
          const newFile = {
            name: fileData.fileId,
            size: file.size,
            uploadTime: new Date(),
            url: fileData.url || fileData.fileUrl,
            fileId: fileData.fileId || fileData.id,
            path: fileData.path || '',
            status: 'success'
          }
          
          this.form.fileList.push(newFile)
          this.$message.success(`文件 ${file.name} 上传成功`)
        } else {
          this.$message.error(`文件 ${file.name} 上传失败，请重试`)
        }
      } catch (error) {
        console.error('文件上传失败:', error)
        this.$message.error(`文件 ${file.name} 上传失败: ${error.message || '未知错误'}`)
      } finally {
        this.uploadingFiles--
      }
    },
    handleRemove(file) {
      const index = this.form.fileList.findIndex(item => 
        (item.uid === file.uid) || (item.name === file.name && item.size === file.size)
      )
      
      if (index !== -1) {
        this.form.fileList.splice(index, 1)
      }
    },
    handleRemoveUploaded(index) {
      this.form.fileList.splice(index, 1)
    },
    beforeUpload(file) {
      // 检查文件大小
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('文件大小不能超过10MB!')
        return false
      }
      
      // 检查文件类型
      const allowedTypes = [
        'application/pdf', 
        'application/msword', 
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'image/jpeg',
        'image/png',
        'image/gif',
        'application/zip',
        'application/x-zip-compressed',
        'application/x-rar-compressed',
        'application/octet-stream',
        'application/x-7z-compressed'
      ]
      
      // 获取文件扩展名
      const fileName = file.name;
      const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();
      const allowedExtensions = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'jpg', 'jpeg', 'png', 'gif', 'zip', 'rar', '7z'];
      
      // 同时检查MIME类型和文件扩展名
      const isAllowedType = allowedTypes.includes(file.type) || allowedExtensions.includes(fileExtension);
      
      if (!isAllowedType) {
        this.$message.warning('请上传PDF、Word、Excel、图片或压缩包(ZIP/RAR/7Z)格式的文件');
        console.log('文件类型不允许:', file.type, fileExtension);
        return false;
      }
      
      return true
    }
  }
}
</script>

<style scoped>
.retest-submit-form {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
}

.retest-form {
  width: 100%;
}

.form-card {
  width: 100%;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.form-card .el-card__header {
  padding: 15px 20px;
  border-bottom: 1px solid #ebeef5;
  font-weight: bold;
}

.form-actions {
  margin-top: 30px;
  text-align: center;
}

.form-actions .el-button {
  min-width: 120px;
  margin: 0 10px;
}

.upload-demo {
  width: 100%;
}

.el-upload__tip {
  margin-top: 10px;
  color: #909399;
}

.file-list-title {
  margin: 0 0 20px 0;
  font-size: 16px;
  color: #303133;
  position: relative;
  padding-left: 12px;
}

.file-list-title:before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 16px;
  background-color: #409eff;
  border-radius: 2px;
}

.uploaded-files {
  margin-top: 20px;
}

.file-list-container {
  margin-top: 20px;
}

.no-file {
  margin-top: 10px;
  text-align: center;
  padding: 10px;
  background-color: #f8f8f8;
  border-radius: 4px;
}

.no-file .el-empty__description {
  font-size: 12px;
}

.no-file .el-empty__image {
  margin-bottom: 5px;
}

/* 确保文本域字体样式与其他输入框一致 */
::v-deep .el-textarea__inner {
  font-family: inherit !important;
  font-size: 14px !important;
  line-height: 1.5 !important;
  color: #606266 !important;
}
</style> 